/**
 * Used for transition durations.
 * In milliseconds.
 */
export const slideDuration: number = 500;
